module.exports = __webpack_public_path__ + "bbe213e8b5f7bf9d0e364cbe82c811d2.png";